export default {
  home: 'Home',
  about: 'About',
  activity: {
    title: 'Activities',
    url: 'activities',
  },
  artwork: {
    title: 'Artworks',
    url: 'artworks',
  },
  artworks: 'Arkworks',
  demo: 'Demo form',
};



// WEBPACK FOOTER //
// ./src/config/locales/en/breadcrumbs.js